import React, {createContext, useContext, useEffect, useState} from 'react';
import {api} from '../services/apiService';

// Création du contexte
const AuthContext = createContext(null);

// Hook personnalisé pour utiliser le contexte facilement
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({children}) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const checkSession = async () => {
            try {
                const response = await api.get('/auth/status');
                if (response.data.isAuthenticated) {
                    setUser(response.data.user);
                } else {
                    setUser(null);
                }
            } catch (error) {
                setUser(null);
            } finally {
                setLoading(false);
            }
        };

        void checkSession();
    }, []);

    const login = async (email, password, remember = false) => {
        try {
            const response = await api.post('/auth/login', {email, password, remember});
            setUser(response.data.user);
            return {success: true};
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || "Erreur de connexion"
            };
        }
    };

    const logout = async () => {
        try {
            await api.post('/auth/logout');
            setUser(null);
            return {success: true};
        } catch (error) {
            console.error("Erreur lors de la déconnexion", error);
            return {success: false, message: "Erreur lors de la déconnexion"};
        }
    };

    const isAdmin = () => {
        return user?.role === 'admin';
    }

    const value = {
        user,
        login,
        logout,
        loading,
        isAdmin,
    };

    return (
        <AuthContext.Provider value={value}>
            {!loading && children}
        </AuthContext.Provider>
    );
};